import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDTTliepySgyEDg-OWcha5A9435U2BHfZ8",
  authDomain: "scipaints-baed8.firebaseapp.com",
  projectId: "scipaints-baed8",
  storageBucket: "scipaints-baed8.firebasestorage.app",
  messagingSenderId: "391617194264",
  appId: "1:391617194264:web:0c36d8ec4b88073592566d",
  measurementId: "G-SEJEZ14514"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app, "asia-south1");
export const storage = getStorage(app);

export default app; 